import SectionHeading from "./SectionHeading";
import { hotList } from "@/mocks/feed";

function TrendIcon({ trend }: { trend: string }) {
  if (trend === "up") return <i className="ri-arrow-up-line text-primary-500" />;
  if (trend === "down") return <i className="ri-arrow-down-line text-secondary-500" />;
  return (
    <span className="font-label text-[10px] text-accent-700 bg-accent-100 px-1.5 py-0.5 rounded-sm">
      NEW
    </span>
  );
}

export default function Ranking() {
  return (
    <section id="ranking" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="RANKING · 本周热度榜"
        title="本周讨论度 Top 10"
        desc="依据页面内讨论量与互动数据综合排序，每周更新一次，仅反映站内热度，不代表事件本身的严重程度。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-1">
        {hotList.map((item) => (
          <div
            key={item.rank}
            className="flex items-center gap-4 py-3.5 border-b border-background-200"
          >
            <span
              className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${
                item.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {item.rank}
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">
                {item.title}
              </h3>
              <div className="mt-1.5 flex items-center gap-3">
                <span className="text-xs text-foreground-500 shrink-0">{item.category}</span>
                <div className="h-1.5 flex-1 bg-background-200 rounded-full overflow-hidden max-w-[220px]">
                  <div
                    className="h-full bg-accent-500 rounded-full"
                    style={{ width: `${item.heat}%` }}
                  />
                </div>
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="font-heading text-base font-bold text-foreground-900">
                {item.heat}
              </div>
              <div className="flex justify-end mt-0.5">
                <TrendIcon trend={item.trend} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}